/* tslint:disable */
/* eslint-disable */
/**
 * Boatsetter API
 * Endpoints require an access token set via the `X-UserToken` header
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { DomesticV3ConfigsSearchGet200Response } from '../models';
/**
 * ExperienceTagApi - axios parameter creator
 * @export
 */
export const ExperienceTagApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns filter config for search
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        domesticV3ConfigsSearchGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/domestic/v3/configs/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication password required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "password", ["read", "write"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ExperienceTagApi - functional programming interface
 * @export
 */
export const ExperienceTagApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ExperienceTagApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns filter config for search
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async domesticV3ConfigsSearchGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DomesticV3ConfigsSearchGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.domesticV3ConfigsSearchGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ExperienceTagApi - factory interface
 * @export
 */
export const ExperienceTagApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ExperienceTagApiFp(configuration)
    return {
        /**
         * Returns filter config for search
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        domesticV3ConfigsSearchGet(options?: any): AxiosPromise<DomesticV3ConfigsSearchGet200Response> {
            return localVarFp.domesticV3ConfigsSearchGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ExperienceTagApi - interface
 * @export
 * @interface ExperienceTagApi
 */
export interface ExperienceTagApiInterface {
    /**
     * Returns filter config for search
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExperienceTagApiInterface
     */
    domesticV3ConfigsSearchGet(options?: AxiosRequestConfig): AxiosPromise<DomesticV3ConfigsSearchGet200Response>;

}

/**
 * ExperienceTagApi - object-oriented interface
 * @export
 * @class ExperienceTagApi
 * @extends {BaseAPI}
 */
export class ExperienceTagApi extends BaseAPI implements ExperienceTagApiInterface {
    /**
     * Returns filter config for search
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExperienceTagApi
     */
    public domesticV3ConfigsSearchGet(options?: AxiosRequestConfig) {
        return ExperienceTagApiFp(this.configuration).domesticV3ConfigsSearchGet(options).then((request) => request(this.axios, this.basePath));
    }
}
